import { ref } from 'vue';
import { useState } from '#app';

export const useTimelineState = () => {
    return {
        timelineInitLoading: useState('timelineInitLoading', () => true),
        timelineLocalLoading: useState('timelineLocalLoading', () => false),
        timelineLoading: useState('timelineLoading', () => false),
        timelineErrors: useState('timelineErrors', () => ({})),
        timelineData: useState('timelineData', () => []),
        dismissingLoading: useState('dismissingLoading', () => ({}))
    };
};